import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function UnsubscribePage() {
  const { subscriberId } = useParams();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!subscriberId) {
      setStatus('invalid');
      return;
    }
    axios.get(`${BACKEND_URL}/api/blog/unsubscribe/${subscriberId}`)
      .then(() => setStatus('success'))
      .catch((err) => {
        if (err.response?.status === 404) setStatus('not_found');
        else setStatus('success');
      });
  }, [subscriberId]);

  return (
    <div style={{
      minHeight: '100vh', background: '#0A0A0A', color: '#EDEDED',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Segoe UI', Arial, sans-serif", padding: '24px'
    }} data-testid="unsubscribe-page">
      <div style={{ textAlign: 'center', maxWidth: '480px' }}>
        {status === 'loading' && (
          <p style={{ color: '#A1A1AA' }}>Memproses permintaan...</p>
        )}
        {status === 'success' && (
          <>
            <h1 style={{ color: '#d9fb06', marginBottom: '16px' }}>Berhasil Berhenti Berlangganan</h1>
            <p style={{ color: '#A1A1AA', lineHeight: '1.6' }}>
              Anda tidak akan menerima email newsletter dari kami lagi.
            </p>
            <p style={{ color: '#71717A', marginTop: '24px', fontSize: '14px' }}>
              Kami menghargai waktu Anda bersama Strategic Thinker. Semoga sukses selalu!
            </p>
          </>
        )}
        {status === 'not_found' && (
          <>
            <h1 style={{ color: '#f87171', marginBottom: '16px' }}>Link Tidak Valid</h1>
            <p style={{ color: '#A1A1AA' }}>Link unsubscribe ini tidak valid atau sudah digunakan.</p>
          </>
        )}
        {status === 'invalid' && (
          <>
            <h1 style={{ color: '#f87171', marginBottom: '16px' }}>Link Tidak Valid</h1>
            <p style={{ color: '#A1A1AA' }}>Terjadi kesalahan pada link unsubscribe.</p>
          </>
        )}
      </div>
    </div>
  );
}
